/**
 * Chunked to stay under `String.fromCharCode`'s argument limit on large
 * inputs — a naive `String.fromCharCode(...bytes)` throws
 * `RangeError: Maximum call stack size exceeded` well before 1 MB.
 */
export const bytesToBase64 = (bytes: Uint8Array): string => {
  let binary = "";

  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }

  return btoa(binary);
};

export const base64ToBytes = (base64: string): Uint8Array => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes;
};
